// TODO: replace with backend-sourced data
// Static list of well-known Islamic cemeteries across Malaysian states.
// Used by the BurialPreferenceInput autocomplete (datalist) as suggestions;
// users can still type any free-text value.

export interface CemeteryOption {
  label: string
  value: string
}

export const MALAYSIAN_CEMETERIES: CemeteryOption[] = [
  // Selangor
  { label: 'Tanah Perkuburan Islam Shah Alam, Selangor', value: 'Tanah Perkuburan Islam Shah Alam, Selangor' },
  { label: 'Raudhatul Sakinah Cemetery, Banting, Selangor', value: 'Raudhatul Sakinah Cemetery, Banting, Selangor' },
  { label: 'Taman Selatan, Putrajaya Border, Selangor', value: 'Taman Selatan, Putrajaya Border, Selangor' },
  { label: 'Tanah Perkuburan Islam Subang Bestari, Selangor', value: 'Tanah Perkuburan Islam Subang Bestari, Selangor' },
  { label: 'Raudhatul Jannah, Sepang, Selangor', value: 'Raudhatul Jannah, Sepang, Selangor' },

  // WP Kuala Lumpur
  { label: 'Tanah Perkuburan Islam Jalan Loke Yew, Kuala Lumpur', value: 'Tanah Perkuburan Islam Jalan Loke Yew, Kuala Lumpur' },
  { label: 'Taman Wahyu Islamic Cemetery, Kuala Lumpur', value: 'Taman Wahyu Islamic Cemetery, Kuala Lumpur' },
  { label: 'Bukit Kiara Muslim Cemetery, Kuala Lumpur', value: 'Bukit Kiara Muslim Cemetery, Kuala Lumpur' },

  // WP Putrajaya
  { label: 'Presint 20 Islamic Cemetery, Putrajaya', value: 'Presint 20 Islamic Cemetery, Putrajaya' },

  // Johor
  { label: 'Tanah Perkuburan Islam Kempas, Johor Bahru, Johor', value: 'Tanah Perkuburan Islam Kempas, Johor Bahru, Johor' },
  { label: 'Makam Sultan Abu Bakar, Johor Bahru, Johor', value: 'Makam Sultan Abu Bakar, Johor Bahru, Johor' },

  // Negeri Sembilan
  { label: 'Taman Selatan Islamic Cemetery, Seremban, Negeri Sembilan', value: 'Taman Selatan Islamic Cemetery, Seremban, Negeri Sembilan' },

  // Melaka
  { label: 'Tanah Perkuburan Islam Bukit Baru, Melaka', value: 'Tanah Perkuburan Islam Bukit Baru, Melaka' },

  // Penang
  { label: 'Tanah Perkuburan Islam Jalan Perak, Penang', value: 'Tanah Perkuburan Islam Jalan Perak, Penang' },
  { label: 'Seberang Jaya Muslim Cemetery, Penang', value: 'Seberang Jaya Muslim Cemetery, Penang' },

  // Perak
  { label: 'Taman Perkuburan Islam Gunung Rapat, Ipoh, Perak', value: 'Taman Perkuburan Islam Gunung Rapat, Ipoh, Perak' },

  // Kedah
  { label: 'Tanah Perkuburan Islam Mergong, Alor Setar, Kedah', value: 'Tanah Perkuburan Islam Mergong, Alor Setar, Kedah' },

  // Kelantan
  { label: 'Tanah Perkuburan Islam Kampung Sireh, Kota Bharu, Kelantan', value: 'Tanah Perkuburan Islam Kampung Sireh, Kota Bharu, Kelantan' },

  // Terengganu
  { label: 'Tanah Perkuburan Islam Kuala Terengganu, Terengganu', value: 'Tanah Perkuburan Islam Kuala Terengganu, Terengganu' },

  // Pahang
  { label: 'Tanah Perkuburan Islam Kuantan, Pahang', value: 'Tanah Perkuburan Islam Kuantan, Pahang' },

  // Selangor (additional)
  { label: 'Tanah Perkuburan Islam Sg Buaya, Hulu Selangor, Selangor', value: 'Tanah Perkuburan Islam Sg Buaya, Hulu Selangor, Selangor' },

  // Sabah
  { label: 'Tanah Perkuburan Islam Likas, Kota Kinabalu, Sabah', value: 'Tanah Perkuburan Islam Likas, Kota Kinabalu, Sabah' },

  // Sarawak
  { label: 'Tanah Perkuburan Islam Samariang, Kuching, Sarawak', value: 'Tanah Perkuburan Islam Samariang, Kuching, Sarawak' },
]
